// Utility functions. Functions should be pure: take in all necessary
// information and return transformed data. Should not be causeing any
// sideeffects.

const utils = {
  calculateRows(images, options) {
    const { clientWidth, thumbnailSize, pixelRatio, spacing } = options;

    // because of rounding errors, use one pixel less than the available width
    let usableClientWidth = clientWidth - 1;
    // start the line with a space
    let curLineWidth = spacing;
    let curCount = 0;
    let curImagesWidth = 0;
    let curLine = [];
    const rows = [];
    let rowCount = 0;

    for (let i = 0; images[i]; i++) {
      const width = images[i]['editedWidth'];
      const height = images[i]['editedHeight'];

      if (width > 0 && height > 0) {
        let calcWidth = (width * thumbnailSize) / pixelRatio / height;
        let calcHeight = thumbnailSize / pixelRatio;
        let startNewLine = false;
        let didDoImage = false;

        if (curLineWidth + calcWidth + spacing <= usableClientWidth) {
          // fits on current line
        } else {
          // doesn't fit directly on the line. There are two possible situations:
          //  - the current line is full, and a new line must be started, or
          //  - the image needs to be resized to fit on the current line
          if (curLineWidth < usableClientWidth / 3) {
            // If the current line is empty, or less than 1/3 filled, force this
            // image on the current line by adding top and bottom padding
            const desiredWidth = usableClientWidth - curLineWidth;
            calcHeight = (desiredWidth / calcWidth) * calcHeight;
            calcWidth = desiredWidth;
          } else {
            startNewLine = true;
          }
        }

        if (startNewLine) {
          const factor =
            (usableClientWidth - (curCount + 1) * spacing) / curImagesWidth;
          rows[rowCount] = [];
          for (let j = 0; curLine[j]; j++) {
            let calcWidthItem = curLine[j]['calcWidth'];
            let calcHeightItem = curLine[j]['calcHeight'];

            // apply the factor
            calcWidthItem = factor * calcWidthItem;
            calcHeightItem = factor * calcHeightItem;
            let margin = 0;
            // calculate top and bottom padding (but only if there is more than
            // one image on the line)
            if (
              calcHeightItem < (factor * thumbnailSize) / pixelRatio &&
              curLine[1]
            ) {
              const diff =
                (factor * thumbnailSize) / pixelRatio - calcHeightItem;
              margin = diff / 2;
              if (margin < 0.5) {
                // ignore margins of less than half a pixel
                margin = 0;
              }
            }
            rows[rowCount][j] = {
              ...curLine[j],
              calcWidth: calcWidthItem,
              calcHeight: calcHeightItem,
              margin,
            };
          }

          // reset row info
          curLine = [];
          curCount = 0;
          curLineWidth = 0;
          curImagesWidth = 0;
          rowCount++;
        } else {
          // image fits on the current line
          curLine[curCount] = { ...images[i], calcWidth, calcHeight };

          // add space between this image and the next
          curLineWidth += calcWidth + spacing;
          // total width of the images doesn't include spaces
          curImagesWidth += calcWidth;
          curCount++;
          didDoImage = true;
        }

        if (!didDoImage) {
          // still need to do current image
          i--;
        }
      }
    }

    // still need to do last line, see streamtest.php for this part

    return rows;
  },

  getImageKey(imageInfo, thumbnailSize) {
    const { imageid } = imageInfo;

    return imageid + '-' + thumbnailSize;
  },

  getRowKey(rowNr, windowWidth, thumbnailSize) {
    return 'r-' + rowNr + '-' + thumbnailSize + '-' + windowWidth;
  },
};

export default utils;
